import { FinancingStructureResponseModel } from "../../models/FinancingStructureResponseModel";
import sendApiRequest from "../../apiRequestHandler";

const CONTROLLER_NAME = "financing-structures";
const CONTROLLER_VERSION = 1;

export async function fetchFinancingStructure(abortController: AbortController): Promise<FinancingStructureResponseModel> {
  return await sendApiRequest(CONTROLLER_NAME, "GET", CONTROLLER_VERSION, abortController.signal);
}
